import { toast } from "sonner";

export const showSuccess = (message: string) => {
  toast.success(message, { style: { background: "#22c55e", color: "#fff" } });
};

export const showError = (message: string) => {
  toast.error(message, { style: { background: "#ef4444", color: "#fff" } });
};

export const showInfo = (message: string) => {
  toast.info(message);
};

export const showWarning = (message: string) => {
  toast.warning(message);
};

export const showSuccessToast = (message: string) => {
  toast.success(message, { style: { background: "#22c55e", color: "#fff" } });
};

export const showErrorToast = (message: string) => {
  toast.error(message, { style: { background: "#ef4444", color: "#fff" } });
};